import 'jsbug'
import Vue from "vue"
import App from "./App"
import Element from 'element-ui'
import PortalVue from 'portal-vue'
import VueKonva from 'vue-konva';
import VueAnalytics from 'vue-analytics'
import * as Sentry from '@sentry/browser'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import MomentPlugin from '@/i18n/moment/locale-filters.js'
import moment from '@/moment-gp.js'
import store from "@/store"
import db from "@/generic_api/config";
// import router from "@/router"
import enLocale from 'element-ui/lib/locale/lang/en'
import { ENABLE_VUE_ANALYTICS, DISABLE_SENRTY } from '@/features.js'
import { mapGetters } from 'vuex'
import { attachTimezoneWatcher, attachDateformatWatcher } from '@/i18n/moment/moment-enhanced.js'
import { attachLanguageWatcher, i18n } from '@/i18n'
// import "@/generic_api/firebase/auth.js"
import "@/misc/filters.js"
import '@/misc/icons.js'
import upperFirst from 'lodash.upperfirst'
import camelCase from 'lodash.camelcase'
import VTooltip from 'v-tooltip'
import fake_router from './router/fake_router'
import { VueResponsiveComponents } from "vue-responsive-components"

/* -------------------- Global CSS imports ---------------------------------- */

// Maybe use skin later:
// import './styles/bootstrap_lumen.css'
// import './styles/tabler.css';
import './styles/tabler/tabler.scss';
import 'element-ui/lib/theme-chalk/index.css';
import './styles/element-ui/elements-fat-style.css';
import './styles/goalpilot/goalpilot.scss';
import 'nprogress/nprogress.css'

/* ------------------------ Import Resource Loader -------------------------- */
let t0 = performance.now();
let loader = require("@/resource-loader.js").default;
// if ( process.browser ) {}
/* Call before app starts loading hook */
loader.beforeAppStartsLoading();
loader.connectRouter( fake_router )
let t1 = performance.now();
console.log("[perf] Loading resource-loader: " + (t1 - t0) + " milliseconds.");
t0 = performance.now();
/*import("@/router").then((real_router) => {
  console.log("LOADING ROUTER DONW", real_router)
  router = real_router;
  loader.connectRouter( router )
});*/
let router = require("@/router").default;
require("@/generic_api/firebase/auth.js");
t1 = performance.now();
console.log("[perf] Loading router + pages: " + (t1 - t0) + " milliseconds.");

/* Initialiazing the loader after the router has been loaded is not optimal,
   because we waste 500 ms if we wait for pages to be loaded. VueLoader should
   actually be the first thing we load. We can still install now: */
// db.attachToRouter( router )
loader.connectRouter( router )

/* ------------------------------- Logging ---------------------------------- */

// log.setLevel("TRACE");
// log.enableAll();
// log.info("Logger started...");
// TODO: create simplified version of bootstrap

/* --------------------------- Vue Plugins ---------------------------------- */

t0 = performance.now();

// TODO: Make date selector global
Vue.use(PortalVue);
Vue.use(Element, { enLocale });
Vue.use(MomentPlugin, { store });
Vue.use(VueKonva);
Vue.use(VueResponsiveComponents)
Vue.use(VTooltip, {
  defaultOffset: 0,
  defaultDelay: 100,
  defaultClass: 'is-dark',
  defaultArrowSelector: '.popper__arrow',
  defaultInnerSelector: '.popper__inner',
  defaultTemplate: '<div class="el-tooltip__popper" role="tooltip"><div x-arrow="" class="popper__arrow"></div><div class="popper__inner"></div></div>',
})

Vue.component('font-awesome-icon', FontAwesomeIcon)

/* Enhance moment js object with Goalpilot specific methods */
attachTimezoneWatcher( moment, store );
attachDateformatWatcher( moment, store );

// /* Set up i18n */
attachLanguageWatcher( store );

t1 = performance.now();
console.log("[perf] Loading vue extensions took " + (t1 - t0) + " milliseconds.");

/* ---------------------------- Tracking ------------------------------------ */

if ( ENABLE_VUE_ANALYTICS ) {
  Vue.use(VueAnalytics, {
    id: 'UA-123642290-1',
    router,
    debug: {
      sendHitTask: process.env.NODE_ENV === 'production',
      enabled: false
    }
  })
}

if ( process.env.NODE_ENV !== 'production' && !DISABLE_SENRTY ) {
  console.log("[Sentry] run...");
  Sentry.init({
    dsn: 'https://cb612b325ec74f5e851c792047f0e795@sentry.io/1338971',
    integrations: [new Sentry.Integrations.Vue({ Vue })]
  })
}

/* ---------------------------- Global Modals ------------------------------- */

var modalMixin = {
  methods: {
    registerModalManager: function ( modalManager ) {
      this.$refs['modalManager'] = modalManager;
    },
    showNewModal: function (modalName, data, isNested) {
      return this.showModal(modalName, data, isNested, false);
    },
    showUpdateModal: function (modalName, data, isNested) {
      return this.showModal(modalName, data, isNested, true);
    },
    showModal: function (modalName, data, isNested, isUpdate) {
      if ( 'modalManager' in this.$refs ) {
        return this.$refs['modalManager'].show(modalName, data, isNested, isUpdate);
      } else {
        throw new Error('No modal manager.')
      }
    }
  }
}

/* ------------------------------ Helpers ----------------------------------- */

if ( process.env.VUE_APP_PRODUCTION === 'false' ) {
  Vue.mixin({
    /* beforeDestroy() {
      // console.log("## global before destroy hook ##", this.$vnode.tag);
      // TODO: loader.removeSubscribtions( this )
    }, */
    computed: {
      ...mapGetters('app', ["SHOW_DEBUG"]),
    }
  });
} else {
  Vue.mixin({
    computed: { SHOW_DEBUG: () => false }
  });
}

Vue.prototype.$forceUpdateRecursive = function(level) {
  if ( level === 0 ) return;
  this.$forceUpdate();
  this.$children.forEach(child => {
    child.$forceUpdateRecursive( level - 1 )
  })
}

/* ---------------------- Require Base Components --------------------------- */
// See: https://github.com/chrisvfritz/7-secret-patterns/blob/master/slides-2018-03-28-vueconfus-export.pdf

t0 = performance.now();

const requireComponent = require.context(
  './components/Elements', false, /[\w-]+\.vue$/
  // './components/Elements', false, /gp-[\w-]+\.vue$/ < TODO: Namespacing!
)

requireComponent.keys().forEach(filename => {
  // Get component config
  const componentConfig = requireComponent(filename)

  // Get PascalCase name of component
  const componentName = upperFirst(
    camelCase(filename.replace(/^\.\//, '').replace(/\.\w+$/, ''))
  )

  // console.log('[load] Autoregister', filename, componentName);

  // Register component globally
  Vue.component(componentName, componentConfig.default || componentConfig);
})

t1 = performance.now();
console.log("[perf] Loading base components: " + (t1 - t0) + " milliseconds.");

/* ---------------------------- Vue Config ---------------------------------- */

/* Set this to false to prevent the production tip on Vue startup. */
Vue.config.productionTip = true;

/* Configure whether to allow vue-devtools inspection. This option’s default
value is true in development builds and false in production builds. You can set
it to true to enable inspection for production builds. */
// Vue.config.devtools = false;

/* Set this to true to enable component init, compile, render and patch
performance tracing in the browser devtool performance/timeline panel.
Only works in development mode and in browsers that support the
performance.mark API. */
// Vue.config.performance = true;

/* Suppress all Vue logs and warnings. */
// Vue.config.silent = true

console.log("[load] Mounting Vue to #app");

/* remove loading div */
document.querySelector('#loading').remove()

/* mount vue */
let rootInstance = new Vue({
  mixins: [modalMixin],
  i18n: i18n,
  router: router,
  db: db,
  store: store,
  el: "#app",
  render: h => h(App)
}).$mount('#app');

/* ---------------------------- Development  -------------------------------- */
/* save some useful variables for development */
if ( process.env.VUE_APP_PRODUCTION === 'false' /* evn.IS_DEV_MODE? */ ) {
  window.gpdev = Object.assign(window.gpdev, {
    i18n:    i18n,
    Vue:     Vue,
    db:      db,
    loader:  loader,
    root:    rootInstance,
    router:  router,
    store:   store,
    moment:  moment
  });
}
